import { render, staticRenderFns } from "./borrow.vue?vue&type=template&id=981719e8&scoped=true"
import script from "./borrow.vue?vue&type=script&lang=js"
export * from "./borrow.vue?vue&type=script&lang=js"
import style0 from "./borrow.vue?vue&type=style&index=0&id=981719e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981719e8",
  null
  
)

export default component.exports